export default function Checkbox({ checked, onChange, children, error }) {
  const errCls = error ? ' has-error' : ''
  return (
    <label className="checkbox-row">
      <input
        type="checkbox"
        className="sr-only"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span
        className={`checkbox-box${errCls}`}
        data-checked={checked ? 'true' : 'false'}
        aria-hidden="true"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          stroke="#ffffff"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.5 6.5L5 9L9.5 3.5" />
        </svg>
      </span>
      <span className="checkbox-label">{children}</span>
    </label>
  )
}
